module.exports = __webpack_public_path__ + "media/images/recruit/section/img-section-sp-6a3996d257e3ececf04a70914a6aa2d8.svg";